import { FC } from 'react';
import { CatHeading } from '@blocks-react/components/Heading';
import { LocationUnavailableProps } from '../../../../../types';

export const LocationUnavailable: FC<LocationUnavailableProps> = ({
  children,
  className
}) => {
  return (
    <CatHeading variant="label-sm" className={`align-middle${className}`}>
      <span className="u-color--MediumGray">{children}</span>
    </CatHeading>
  );
};
